'use strict';

import debounce from './debounce';

import $ from 'jquery';
import scrollTo from './scroll-to';

window.jQuery = $;
require('sticky-kit/dist/sticky-kit.js');

let dom = {};

const navs = {
  mobileMainNavToggled: false,
  sideNavToggled: false,
  desktopNavBreakpoint: window.matchMedia('(min-width: 992px)'),

  toggleSideNav(bool) {
    dom.$sideNavToggles.attr('aria-expanded', bool ? 'true' : 'false');
    dom.$sideNavItems.attr('aria-hidden', bool ? null : 'true');
    dom.$sideNav.trigger('sticky_kit:recalc'); // recalc

    this.sideNavToggled = bool;
  },

  toggleMobileMainNav(bool) {
    bool = (typeof bool === 'boolean' ? bool : !this.mobileMainNavToggled);
    this.mobileMainNavToggled = bool;
    dom.$mobileMainNavWrap.toggle(bool);
    dom.$body.toggleClass('mobile-main-nav-visible', bool);
    dom.$mobileMainNavToggles.attr('aria-expanded', bool ? 'true' : 'false');
    if(!bool) {
      // is hidden
      dom.$mobileMainNavToggles.removeClass('selected');
    } else {
      // is visible
      dom.$mobileMainNavToggles.addClass('selected');
      $(document).trigger('scroll'); // trigger scroll
      dom.$mobileMainNav.find('a.main-nav__link').get(0).focus();
    }
  },

  updateMobileHeaderStickyPositions() {
    const scrollTop = $(window).scrollTop();
    const scrollDelta = scrollTop-this.lastScrollTop;

    if(dom.$body.hasClass('mobile-main-nav-visible')) {
      // In case the mobile main nav is visible > keep heared in top of the viewport and
      this.mobileHeaderCurrentTop = 0;
    } else if(scrollTop < 0){
      this.mobileHeaderCurrentTop = Math.abs(scrollTop);
    } else if(scrollDelta > 0){
      // Scrolling down
      this.mobileHeaderCurrentTop = Math.max((this.mobileHeaderCurrentTop-scrollDelta), this.mobileHeaderMinTop);
    } else {
      // Scrolling up
      this.mobileHeaderCurrentTop = Math.min((this.mobileHeaderCurrentTop-scrollDelta), 0);
    }

    dom.$mobileHeader.css({top: this.mobileHeaderCurrentTop});
    dom.$mobileHeaderIndexNav.css({top: this.mobileHeaderCurrentTop + this.mobileHeaderHeight});

    this.lastScrollTop = scrollTop;
  },

  initDesktopMainNav() {
    const self = this;
    const itemOpenClass = 'main-nav__item--open';

    dom.$desktopNavToggles.on('click', function(evt) {
    // Has megamenu, open it
      if($(this).siblings('.main-nav__sub-nav').length) {
        evt.preventDefault();
        evt.stopPropagation();

        if($(this).parent().hasClass(itemOpenClass)) {
          self.toggleDesktopMainNav();
        } else {
          self.toggleDesktopMainNav(evt.currentTarget);
        }
      }
    });
  },

  /**
   * Toggles the meganav open/closed
   *
   * @param {HTMLElement} target - The event target element (main nav item or its descendant)
   */
  toggleDesktopMainNav(target) {
    const itemOpenClass = 'main-nav__item--open';
    dom.$desktopMainNavItems.removeClass(itemOpenClass);
    dom.$desktopNavToggles.attr('aria-expanded', false);

    // Show particular menu
    if(typeof target !== 'undefined') {
      const $item = $(target).closest('.main-nav__item');
      if($item.children('.main-nav__sub-nav').length) {
        $item.addClass(itemOpenClass);
        $(target).attr('aria-expanded', true);
      }
    }
  },

  generateSubNavFromHeadings(){
    const $sideNavCurrentLink = $('.side-nav-items .side-nav__link--current, .side-nav-items .side-nav__sub-nav-link--current')

    const $subNavForHeadings = $('<div class="side-nav__sub-nav-2 pb-4"></div>');
    const $headings = $('#pageContent .element-text').find('h2, h3');

    $headings.each(function(index){
      const $heading = this;
      const isH2 = $($heading).prop('tagName') === 'H2';

      const $item = $('<div class="side-nav__sub-nav-2-item"></div>');

      const $link = isH2
        ? $('<a href="#" class="side-nav__sub-nav-2-link '+(index === 0 ? '' : 'pt-4')+'"></a>')
        : $('<a href="#" class="side-nav__sub-nav-2-link py-2"></a>')

      const $index = isH2
        ? $('<span class="side-nav__sub-nav-2-link-index"><span class="icon-right-dir"></span></span>')
        : $('<span class="side-nav__sub-nav-2-link-index"></span>');
      //$index.text(index);

      const $text = isH2
        ? $('<span class="side-nav__sub-nav-2-link-text font-weight-bold"></span>')
        : $('<span class="side-nav__sub-nav-2-link-text"></span>')
      $text.text(this.textContent);

      $link.append($index)
      $link.append($text)
      $item.append($link);
      $subNavForHeadings.append($item)

      $link.on('click', function(evt){
        evt.preventDefault();
        const scrollOffsetTop = (dom.$mobileHeader.is(':visible') ? dom.$mobileHeader.height() : 0) + 20;

        scrollTo($heading, {
          offsetTop: -scrollOffsetTop
        })
      })
    })

    $sideNavCurrentLink.after($subNavForHeadings)

    /*

    This is the Mustache template from Stage: https://spvk.stage.crasman.cloud/admin/manage/scriptlets/scriptleteditor/page_url/subtemplate/show/MuDHZsOPQ_q0x_DJ7k6I9Q

    {{#children.length}}
      <div class="side-nav__sub-nav">

      {{#children}}
        <div class="side-nav__sub-nav-item">
          <a href="{{{url}}}" class="side-nav__sub-nav-link{{#selected}} side-nav__sub-nav-link--selected{{/selected}}{{#current}} side-nav__sub-nav-link--current{{/current}}">
            <span class="side-nav__sub-nav-link-index">
              {{#meta_data.indexNum}}{{meta_data.indexNum}}{{/meta_data.indexNum}}
            </span>
            <span class="side-nav__sub-nav-link-text">{{name}}</span>
          </a>

          {{#children.length}}
            <div class="side-nav__sub-nav-2">
              {{#children}}
                <div class="side-nav__sub-nav-2-item">
                  <a href="{{{url}}}" class="side-nav__sub-nav-2-link{{#selected}} side-nav__sub-nav-2-link--selected{{/selected}}{{#current}} side-nav__sub-nav-2-link--current{{/current}}">
                    <span class="side-nav__sub-nav-2-link-index">
                      <span class="icon-right-dir"></span>
                    </span>
                    <span class="side-nav__sub-nav-2-link-text">{{name}}</span>
                  </a>
                </div>
              {{/children}}
            </div>
          {{/children.length}}

        </div>
      {{/children}}

      </div>
    {{/children.length}}

    */
  },

  /**
   * Updates mobile header height on resize
   * when changing from desktop to mobile.
   * Debounced.
   */
  updateMobileHeaderHeight: debounce(function () {
    if(this.desktopNavBreakpoint.matches === false && this.lastBreakpointMatch !== this.desktopNavBreakpoint.matches) {
      dom.$mobileHeaderWrap.css({height: dom.$mobileHeader.height()+'px'});
    }

    if(this.lastBreakpointMatch !== this.desktopNavBreakpoint.matches) {
      this.lastBreakpointMatch = this.desktopNavBreakpoint.matches;
    }
  }, 100),

  init() {
    const self = this;

    dom.$body = $('body');

    dom.$desktopMainNav = $('.js-main-nav-desktop');
    dom.$desktopMainNavItems = dom.$desktopMainNav.find('.main-nav__item');
    dom.$desktopNavToggles = $('.main-nav--desktop .main-nav__link[aria-expanded]');

    dom.$sideNav = $('.side-nav');
    dom.$sideNavItems = dom.$sideNav.find('.side-nav-items');
    dom.$sideNavToggles = dom.$sideNav.find('[data-toggle-sidebar]');

    dom.$mobileHeaderWrap = $('.mobile-header-wrap');
    dom.$mobileHeader = $('.mobile-header');
    dom.$mobileHeaderMainBar = $('.mobile-header__main-bar');
    dom.$mobileHeaderYearBar = $('.mobile-header__year-bar');
    dom.$mobileHeaderIndexNavBar = $('.mobile-header .side-nav-wrapper');
    dom.$mobileHeaderIndexNav = $('.mobile-header .side-nav-wrapper .side-nav-items');

    dom.$mobileMainNavWrap = $('#mobileMainNavWrap');
    dom.$mobileMainNavToggles = $('[data-mobile-main-nav-toggle]');

    dom.$mobileMainNav = $('.main-nav--mobile');
    dom.$mobileSubNavToggles = $('.main-nav--mobile .main-nav__link[aria-expanded]');

    this.generateSubNavFromHeadings()

    this.lastScrollTop = 0;
    this.mobileHeaderCurrentTop = 0;
    this.mobileHeaderHeight = dom.$mobileHeaderWrap.height();
    this.mobileHeaderNavBarHeight = dom.$mobileHeaderIndexNavBar.height();
    this.mobileHeaderMinTop = -(this.mobileHeaderHeight-this.mobileHeaderNavBarHeight);

    if (this.desktopNavBreakpoint.matches) {
      dom.$sideNav.stick_in_parent({
        offset_top: 15
      });
    }
    else {
      this.toggleSideNav(false);
    }

    dom.$sideNavToggles.on('click', function(evt) {
      const $this = $(this);
      evt.stopPropagation();
      evt.preventDefault();
      const bool = $this.attr('aria-expanded') === 'true' ? false : true;
      self.toggleSideNav(bool);
    })

    dom.$mobileMainNavToggles.on('click', function(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      self.toggleMobileMainNav();
    })

    dom.$mobileSubNavToggles.on('click', function(evt) {
      const $this = $(this);
      evt.stopPropagation();
      evt.preventDefault();
      if ($this.attr('aria-expanded') === 'false') {
        $this.attr('aria-expanded', 'true');
        $this.closest('.main-nav__link').addClass('main-nav__link--sub-nav-toggled');
      }
      else {
        $this.attr('aria-expanded', 'false');
        $this.closest('.main-nav__link').removeClass('main-nav__link--sub-nav-toggled');
      }
    })

    // "click" sub nav's current link-toggle
    dom.$mobileMainNavWrap.find('.main-nav__link--selected .main-nav__link-toggle').trigger('click');

    // Set mobile header wrap height and set to fixed
    dom.$mobileHeaderWrap.css({height: dom.$mobileHeaderWrap.height()+'px'});
    dom.$mobileHeader.css({position: 'fixed', width: '100%'});

    $(document).on('scroll', function() {
      self.updateMobileHeaderStickyPositions();
    })
    .on('keydown', (e) => {
      // Close menu when escape is pressed and move focus to toggle button
      if (e.key === 'Esc' || e.key === 'Escape') {
        if (this.mobileMainNavToggled) {
          this.toggleMobileMainNav();
          dom.$mobileMainNavToggles.get(0).focus();
        }

        //desktop nav
        if(self.desktopNavBreakpoint.matches && dom.$desktopMainNav.length) {
          //if focus is inside menu area, move it to the active toggle. Close menu.
          const activeToggle = dom.$desktopMainNav[0].querySelector('.main-nav__link[aria-expanded="true"]');
          if(activeToggle && dom.$desktopMainNav[0].contains(document.activeElement)) {
            activeToggle.focus();
          }
          this.toggleDesktopMainNav();
        }
      }
    });

    //close desktop menu if user clicked outside of it
    document.addEventListener('click', (e)=> {
      if(self.desktopNavBreakpoint.matches && dom.$desktopMainNav.length) {
        if(!dom.$desktopMainNav[0].contains(e.target)) {
          this.toggleDesktopMainNav();
        }
      }
    });

    // Update mobile header sticky positions
    self.updateMobileHeaderStickyPositions();

    self.initDesktopMainNav();

    $(window).on('resize', function() {
      self.updateMobileHeaderHeight();

      // Remove aria-hidden on desktop
      if (!self.sideNavToggled) {
        dom.$sideNavItems.attr('aria-hidden', self.desktopNavBreakpoint.matches ? null : 'true');
      }
    });

  }
}

module.exports = navs;
